<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { AssetField } from '../../../AssetField.js';
    import { getPublicUrl } from '../../../getPublicUrl.js';

    export let mtappVars;
    export let id;
    export let item;
    let assetFieldInstance;

    $: assetAddButtonLabel = item.buttonLabel ? item.buttonLabel : `${item.label}を選択`;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }

    onMount(() => {
        assetFieldInstance = new AssetField(id, item.type);
        if (typeof item.uploadDirectory === 'string') {
            window.mtappVars.__system.assetField.uploadDirectories[id] = item.uploadDirectory;
        } else if (Array.isArray(item.uploadDirectory)) {
            window.mtappVars.__system.assetField.uploadDirectories[id] = [...item.uploadDirectory];
        }
    });

    /**
     * URL からファイル名を取得する
     *
     * @param {string} url
     */
    function getFilename(url) {
        return url ? new URL(url, url.startsWith('http') ? undefined : window.location.origin).pathname.split('/').pop() : '';
    }
    function select() {
        return assetFieldInstance.select();
    }

    function remove() {
        item.data = '';
        item.url = '';
        if (item.type === 'image') {
            item.thumbnail = '';
        }
        triggerInputChange();
        return assetFieldInstance.remove();
    }
</script>

<div data-handle={item.type}>
    <input id={id} class="form-control mtapp-mf-field-{item.type}" type="hidden" bind:value={item.data} on:blur={triggerInputChange} />
    <input id={id + '-url'} class="form-control" type="hidden" bind:value={item.url} on:blur={triggerInputChange} />
    {#if item.type === 'image'}
        <input
            id={id + '-thumb'}
            class="form-control mtapp-mf-field-thumbnail"
            type="hidden"
            bind:value={item.thumbnail}
            on:blur={triggerInputChange} />
    {/if}

    {#if item.url}
        <a href={getPublicUrl(item.url)} target="_blank" class="d-block pb-2">
            {#if item.type === 'image' && item.thumbnail}
                <img src={getPublicUrl(item.thumbnail)} class="img-fluid" alt={item.label} />
            {:else}
                <svg role="img" class="mt-icon">
                    <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_file'} />
                </svg>
                {getFilename(item.url)}
            {/if}
        </a>
    {/if}

    <div class="btn-group" role="group">
        <button type="button" class="btn btn-default" on:click|preventDefault={select}>{assetAddButtonLabel}</button>
        {#if item.url}
            <button type="button" on:click|preventDefault={remove} class="btn btn-default p-1 assetField-remove-image" aria-label="Remove">
                <svg role="img" class="mt-icon">
                    <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_trash'} />
                </svg>
            </button>
        {/if}
    </div>

    {#if typeof item.textFieldLabel !== 'undefined' && item.textFieldLabel}
        <div class="mt-3 mb-0">
            <label for={id + '-alt'}>{item.textFieldLabel}</label>
            <input id={id + '-alt'} class="form-control" type="text" bind:value={item.alt} on:blur={triggerInputChange} />
        </div>
    {/if}
</div>
